export default "__VITE_ASSET__52be8641__"